import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

// Platform tokens are imported BEFORE the landing-specific stylesheet so that
// landing.css can extend / override semantic variables if needed.
import "@shared/tokens/tokens.css";
import "./styles/landing.css";

const root = document.getElementById("root");
if (!root) throw new Error("Root container missing");

createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
